import React, { useEffect, useState } from 'react';
import EditableTable from '../EditableTable/index.js';
import classNames from 'classnames';
import { getCampaignsExecutionsColumns } from '../../../services/settingsSectionModels/campaigns.js';
import { getTranslateTitle } from '../../../utils/objects-util.js';

import './index.scss';
import { connect } from 'react-redux';
import { getHistoryLocationParams } from '../../../utils/routesHelper.js';
import { isRTL } from '../../../services/userModel.js';

const CustomerListTable = ({ values, campaigns }) => {
  const { id: campaignId } = getHistoryLocationParams(window.location.search);
  const campaign = campaigns?.find(campaign => campaign?.id === campaignId) || null;
  const [executions, setExecutions] = useState(null);

  useEffect(() => {
    if (!campaign) return;

    const newItems = campaign?.executions?.filter(execution => values.some(value => value.id === execution.id));
    setExecutions(newItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaigns, values]);
  const model = {
    columns: getCampaignsExecutionsColumns(),
  };

  if (!executions) return null;

  return (
    <div className={classNames('sectionItemEditableTable', { rlt: isRTL() })}>
      <table>
        <tbody>
          <tr>
            {model.columns.map((column, index) => {
              return (
                <td
                  key={`headerItem-${column.title}-${index}`}
                  className={classNames('headerItem', {
                    centered: column.centered,
                  })}
                  style={{
                    width: column.width ? `${column.width}` : `auto`,
                    textAlign: column.textRight ? 'right' : '',
                  }}
                >
                  {getTranslateTitle(column.title)}
                  &nbsp;
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      <EditableTable model={model} items={executions} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    campaigns: state.restaurant.data.campaigns,
  };
};

export default connect(mapStateToProps)(CustomerListTable);
